<div class="padding">
    <div class="card card-1 padding table-wrapper" *ngIf="!is_loading && storeObject">
        <app-fb-forms-table [storeObj]="storeObject"
                            [edit_allowed]="is_admin"
                            (row_click)="rowSelected($event)"
                            [stateKey]="'sc-public-commodity-inventory'"
                            [show_add_in_view]="is_admin"
                            [show_delete]="is_admin"
                            [title]="'Inventory'"
                            [storeExtObj]="{}"
                            [footer_tpl]="footer_tpl"
                            (selectionChange)="rowSelectionChanged($event)"
        >
        </app-fb-forms-table>
    </div>
</div>

<ng-template #footer_tpl>
    <ng-container *ngIf="selectedRows.length > 0">
        <button mat-raised-button class="button-add"
                style="margin-top: -14px;"
                (click)="openMultiLogDialog()"
                matTooltip="book"
                type="button">
            book
        </button>
    </ng-container>
</ng-template>